// 📁 hooks/useClickToRefreshSession.ts
import { useEffect } from "react";

interface SessionHandler {
    getToken: () => string | null;
    RefreshSession: () => void;
}

export function useClickToRefreshSession(sessionHandler: SessionHandler) {
    useEffect(() => {
        const token = sessionHandler.getToken();
        let handleClick: () => void;

        if (token) {
            handleClick = () => {
                sessionHandler.RefreshSession();
            };
            window.addEventListener("click", handleClick);
        }

        return () => {
            if (token && handleClick) {
                window.removeEventListener("click", handleClick);
            }
        };
    }, [sessionHandler]);
}
